import { supabase } from '../../adapters/database/supabaseClient'
import type { Capability } from '../capabilities/capability'
import type { EnabledModule, Membership, Organization } from './types'

export async function listOrganizations(): Promise<Organization[]> {
  const { data, error } = await supabase
    .from('organizations')
    .select('id,slug,display_name,status,theme,settings')
    .eq('status', 'active')
    .order('display_name')

  if (error) throw error
  return (data ?? []).map(row => ({
    id: row.id,
    slug: row.slug,
    displayName: row.display_name,
    status: row.status,
    theme: row.theme ?? {},
    settings: row.settings ?? {},
  }))
}

export async function getMembership(organizationId: string): Promise<Membership> {
  const { data: member, error: memberError } = await supabase
    .from('organization_members')
    .select('organization_id,role_key')
    .eq('organization_id', organizationId)
    .limit(1)
    .maybeSingle()
  if (memberError) throw memberError
  if (!member) throw new Error('Accesso organizzazione non disponibile per questo utente')

  const { data: capabilityRows, error: capabilityError } = await supabase
    .from('role_capabilities')
    .select('capability')
    .eq('organization_id', organizationId)
    .eq('role_key', member.role_key)
  if (capabilityError) throw capabilityError

  return {
    organizationId: member.organization_id,
    roleKey: member.role_key,
    capabilities: (capabilityRows ?? []).map(row => row.capability as Capability),
  }
}

export async function listEnabledModules(organizationId: string): Promise<EnabledModule[]> {
  const { data, error } = await supabase
    .from('organization_modules')
    .select('module_id,version')
    .eq('organization_id', organizationId)
    .eq('enabled', true)

  if (error) throw error
  return (data ?? []).map(row => ({ moduleId: row.module_id, version: row.version }))
}
